import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="restore-attribute-on-morph"
export default class extends Controller {
  static values = {
    attributes: { type: Array, default: [] }
  }

  beforeMorphValues = {}

  connect () {
    this.beforeMorphListener = document.addEventListener('turbo:before-morph-element', (e) => {
      if (e.target !== this.element) {
        return
      }

      this.attributesValue.forEach(attribute => {
        this.beforeMorphValues[attribute] = this.element.getAttribute(attribute)
      })
    })

    this.afterMorphListener = document.addEventListener('turbo:morph', () => {
      this.attributesValue.forEach(attribute => {
        const beforeValue = this.beforeMorphValues[attribute]
        if (beforeValue === null) {
          this.element.removeAttribute(attribute)
        } else {
          this.element.setAttribute(attribute, beforeValue)
        }
      })
    })
  }

  disconnect () {
    document.removeEventListener('turbo:before-morph-element', this.beforeMorphListener)
    document.removeEventListener('turbo:morph', this.afterMorphListener)
  }
}
